import { render } from "./Rich_Text_Editor.vue?vue&type=template&id=c37c3bf2&scoped=true"
import script from "./Rich_Text_Editor.vue?vue&type=script&lang=js"
export * from "./Rich_Text_Editor.vue?vue&type=script&lang=js"

import "./Rich_Text_Editor.vue?vue&type=style&index=0&id=c37c3bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37c3bf2"]])

export default __exports__